import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';
import {
  Main,
  DesktopLogo,
  ContentWrapper,
  BackgroundImage,
  BaseOuterContainer,
  BaseInnerContainer,
  BaseSmallAndMediumHeader,
  BaseSecureTextAndIconDesktopWrapper
} from './shared.style';

// SimpleLayout-specific styled components
const OuterContainer = styled(BaseOuterContainer)`
  background-color: ${crTheme.color('blue_donate')};
`;

const InnerContainer = styled(BaseInnerContainer)`
  @media ${crTheme.allBreakpoints('M')} {
    background-color: ${crTheme.color('white')};
    border-radius: 1rem;
    margin: 60px 0;
    width: 565px;
  }
`;

const HeaderImage = styled.img`
  display: block;
  width: calc(100% + 80px);
  margin: -40px -40px 40px;
`;

const SmallAndMediumHeader = styled(BaseSmallAndMediumHeader)`
  background: ${crTheme.color('grey_light')};
  border-bottom: 1px solid ${crTheme.color('grey_medium')};
`;

const SecureTextAndIconDesktopWrapper = styled(BaseSecureTextAndIconDesktopWrapper)`
  bottom: 2rem;
  right: 2rem;
`;

export {
  Main, OuterContainer, InnerContainer, HeaderImage, ContentWrapper, BackgroundImage,
  SmallAndMediumHeader, DesktopLogo, SecureTextAndIconDesktopWrapper
};
